/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FastEndpointsProblemDetails,
  FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse,
  FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult,
  FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest,
  FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponse,
  FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponse,
  FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand,
  FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest,
  FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponse,
  FxIdWebFeaturesAuthAuthenticateFromFirebaseRequest,
  FxIdWebFeaturesAuthAuthenticateFromFirebaseResponse,
  FxIdWebFeaturesAuthAuthenticateFromGameRequest,
  FxIdWebFeaturesAuthAuthenticateFromGameResponse,
  FxIdWebFeaturesAuthAuthenticateFromImportRequest,
  FxIdWebFeaturesAuthAuthenticateFromImportResponse,
  FxIdWebFeaturesAuthAuthenticateFromSocialRequest,
  FxIdWebFeaturesAuthAuthenticateFromSocialResponse,
  FxIdWebFeaturesAuthAuthenticateFromTokenRequest,
  FxIdWebFeaturesAuthAuthenticateFromTokenResponse,
  FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest,
  FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse,
  FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest,
  FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponse,
  FxIdWebFeaturesAuthAuthenticateWithExternalIdRequest,
  FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse,
  FxIdWebFeaturesAuthCreateTempTokenRequest,
  FxIdWebFeaturesAuthCreateTempTokenResponse,
  FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest,
  FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponse,
  FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest,
  FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthResponse,
  FxIdWebFeaturesAuthOauthUserInfoResponse,
  FxIdWebFeaturesAuthTwitchConnectRequest,
  FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest,
} from '../models/index';
import {
    FastEndpointsProblemDetailsFromJSON,
    FastEndpointsProblemDetailsToJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseFromJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseToJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultFromJSON,
    FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestToJSON,
    FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseFromJSON,
    FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseToJSON,
    FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseFromJSON,
    FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseToJSON,
    FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandFromJSON,
    FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandToJSON,
    FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestToJSON,
    FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseToJSON,
    FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestToJSON,
    FxIdWebFeaturesAuthAuthenticateFromFirebaseResponseFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromFirebaseResponseToJSON,
    FxIdWebFeaturesAuthAuthenticateFromGameRequestFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromGameRequestToJSON,
    FxIdWebFeaturesAuthAuthenticateFromGameResponseFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromGameResponseToJSON,
    FxIdWebFeaturesAuthAuthenticateFromImportRequestFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromImportRequestToJSON,
    FxIdWebFeaturesAuthAuthenticateFromImportResponseFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromImportResponseToJSON,
    FxIdWebFeaturesAuthAuthenticateFromSocialRequestFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromSocialRequestToJSON,
    FxIdWebFeaturesAuthAuthenticateFromSocialResponseFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromSocialResponseToJSON,
    FxIdWebFeaturesAuthAuthenticateFromTokenRequestFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromTokenRequestToJSON,
    FxIdWebFeaturesAuthAuthenticateFromTokenResponseFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromTokenResponseToJSON,
    FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestToJSON,
    FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseFromJSON,
    FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseToJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFromJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestToJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseFromJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseToJSON,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestFromJSON,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestToJSON,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseFromJSON,
    FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseToJSON,
    FxIdWebFeaturesAuthCreateTempTokenRequestFromJSON,
    FxIdWebFeaturesAuthCreateTempTokenRequestToJSON,
    FxIdWebFeaturesAuthCreateTempTokenResponseFromJSON,
    FxIdWebFeaturesAuthCreateTempTokenResponseToJSON,
    FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequestFromJSON,
    FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequestToJSON,
    FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseFromJSON,
    FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseToJSON,
    FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestFromJSON,
    FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestToJSON,
    FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthResponseFromJSON,
    FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthResponseToJSON,
    FxIdWebFeaturesAuthOauthUserInfoResponseFromJSON,
    FxIdWebFeaturesAuthOauthUserInfoResponseToJSON,
    FxIdWebFeaturesAuthTwitchConnectRequestFromJSON,
    FxIdWebFeaturesAuthTwitchConnectRequestToJSON,
    FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestFromJSON,
    FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestToJSON,
} from '../models/index';

export interface FxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpointRequest {
    fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest: FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest;
}

export interface FxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpointRequest {
    game: string;
    fbLocale: string;
    signedRequest: string;
}

export interface FxIdWebFeaturesAuthAuthenticateFromFirebaseEndpointRequest {
    fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest: FxIdWebFeaturesAuthAuthenticateFromFirebaseRequest;
}

export interface FxIdWebFeaturesAuthAuthenticateFromGameEndpointRequest {
    fxIdWebFeaturesAuthAuthenticateFromGameRequest: FxIdWebFeaturesAuthAuthenticateFromGameRequest;
}

export interface FxIdWebFeaturesAuthAuthenticateFromImportEndpointRequest {
    fxIdWebFeaturesAuthAuthenticateFromImportRequest: FxIdWebFeaturesAuthAuthenticateFromImportRequest;
}

export interface FxIdWebFeaturesAuthAuthenticateFromSocialEndpointRequest {
    fxIdWebFeaturesAuthAuthenticateFromSocialRequest: FxIdWebFeaturesAuthAuthenticateFromSocialRequest;
}

export interface FxIdWebFeaturesAuthAuthenticateFromTokenEndpointRequest {
    fxIdWebFeaturesAuthAuthenticateFromTokenRequest: FxIdWebFeaturesAuthAuthenticateFromTokenRequest;
}

export interface FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiEndpointRequest {
    fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest: FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest;
}

export interface FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdEndpointRequest {
    fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest;
}

export interface FxIdWebFeaturesAuthAuthenticateToFxIdEndpointRequest {
    fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest;
}

export interface FxIdWebFeaturesAuthAuthenticateWithExternalIdEndpointRequest {
    game: string;
    fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest: FxIdWebFeaturesAuthAuthenticateWithExternalIdRequest;
}

export interface FxIdWebFeaturesAuthCreateTempTokenEndpointRequest {
    fxIdWebFeaturesAuthCreateTempTokenRequest: FxIdWebFeaturesAuthCreateTempTokenRequest;
}

export interface FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthEndpointRequest {
    fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest: FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest;
}

export interface FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthEndpointRequest {
    fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest: FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest;
}

export interface FxIdWebFeaturesAuthTwitchConnectEndpointRequest {
    fxIdWebFeaturesAuthTwitchConnectRequest: FxIdWebFeaturesAuthTwitchConnectRequest;
}

export interface FxIdWebFeaturesAuthTwitchRefreshAccessTokenEndpointRequest {
    fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest: FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest;
}

export interface FxIdWebFeaturesAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenRequest {
    fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand: FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand;
}

export interface GetFxIdWebFeaturesAuthOauthUserInfoEndpointRequest {
    game: string;
}

export interface PostFxIdWebFeaturesAuthOauthUserInfoEndpointRequest {
    game: string;
}

/**
 * 
 */
export class AuthApi extends runtime.BaseAPI {

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user by email invite token 
     */
    async fxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest',
                'Required parameter "fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_email_invite`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user by email invite token 
     */
    async fxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpoint(fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest: FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthAuthenticateFromEmailInviteResponse> {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromEmailInviteEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest: fxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user from facebook games 
     */
    async fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError(
                'game',
                'Required parameter "game" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpoint().'
            );
        }

        if (requestParameters['fbLocale'] == null) {
            throw new runtime.RequiredError(
                'fbLocale',
                'Required parameter "fbLocale" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpoint().'
            );
        }

        if (requestParameters['signedRequest'] == null) {
            throw new runtime.RequiredError(
                'signedRequest',
                'Required parameter "signedRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'application/x-www-form-urlencoded' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['fbLocale'] != null) {
            formParams.append('FbLocale', requestParameters['fbLocale'] as any);
        }

        if (requestParameters['signedRequest'] != null) {
            formParams.append('SignedRequest', requestParameters['signedRequest'] as any);
        }

        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_facebook_games/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user from facebook games 
     */
    async fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpoint(game: string, fbLocale: string, signedRequest: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fxIdWebFeaturesAuthAuthenticateFromFacebookGamesEndpointRaw({ game: game, fbLocale: fbLocale, signedRequest: signedRequest }, initOverrides);
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user via firebase admin sdk 
     */
    async fxIdWebFeaturesAuthAuthenticateFromFirebaseEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateFromFirebaseEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthAuthenticateFromFirebaseResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest',
                'Required parameter "fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromFirebaseEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_firebase`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromFirebaseRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromFirebaseResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user via firebase admin sdk 
     */
    async fxIdWebFeaturesAuthAuthenticateFromFirebaseEndpoint(fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest: FxIdWebFeaturesAuthAuthenticateFromFirebaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthAuthenticateFromFirebaseResponse> {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromFirebaseEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest: fxIdWebFeaturesAuthAuthenticateFromFirebaseRequest }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using game\'s jwt token (JwtSecret) 
     */
    async fxIdWebFeaturesAuthAuthenticateFromGameEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateFromGameEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthAuthenticateFromGameResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromGameRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthAuthenticateFromGameRequest',
                'Required parameter "fxIdWebFeaturesAuthAuthenticateFromGameRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromGameEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_game`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromGameRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromGameRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromGameResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using game\'s jwt token (JwtSecret) 
     */
    async fxIdWebFeaturesAuthAuthenticateFromGameEndpoint(fxIdWebFeaturesAuthAuthenticateFromGameRequest: FxIdWebFeaturesAuthAuthenticateFromGameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthAuthenticateFromGameResponse> {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromGameEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromGameRequest: fxIdWebFeaturesAuthAuthenticateFromGameRequest }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections` 
     */
    async fxIdWebFeaturesAuthAuthenticateFromImportEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateFromImportEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthAuthenticateFromImportResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromImportRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthAuthenticateFromImportRequest',
                'Required parameter "fxIdWebFeaturesAuthAuthenticateFromImportRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromImportEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromImportRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromImportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromImportResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections` 
     */
    async fxIdWebFeaturesAuthAuthenticateFromImportEndpoint(fxIdWebFeaturesAuthAuthenticateFromImportRequest: FxIdWebFeaturesAuthAuthenticateFromImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthAuthenticateFromImportResponse> {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromImportEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromImportRequest: fxIdWebFeaturesAuthAuthenticateFromImportRequest }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using social network login 
     */
    async fxIdWebFeaturesAuthAuthenticateFromSocialEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateFromSocialEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthAuthenticateFromSocialResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromSocialRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthAuthenticateFromSocialRequest',
                'Required parameter "fxIdWebFeaturesAuthAuthenticateFromSocialRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromSocialEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_social`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromSocialRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromSocialRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromSocialResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using social network login 
     */
    async fxIdWebFeaturesAuthAuthenticateFromSocialEndpoint(fxIdWebFeaturesAuthAuthenticateFromSocialRequest: FxIdWebFeaturesAuthAuthenticateFromSocialRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthAuthenticateFromSocialResponse> {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromSocialEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromSocialRequest: fxIdWebFeaturesAuthAuthenticateFromSocialRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Authenticates user using temp jwt token 
     */
    async fxIdWebFeaturesAuthAuthenticateFromTokenEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateFromTokenEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthAuthenticateFromTokenResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthAuthenticateFromTokenRequest',
                'Required parameter "fxIdWebFeaturesAuthAuthenticateFromTokenRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromTokenEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_temp_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromTokenRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromTokenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromTokenResponseFromJSON(jsonValue));
    }

    /**
     * Authenticates user using temp jwt token 
     */
    async fxIdWebFeaturesAuthAuthenticateFromTokenEndpoint(fxIdWebFeaturesAuthAuthenticateFromTokenRequest: FxIdWebFeaturesAuthAuthenticateFromTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthAuthenticateFromTokenResponse> {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromTokenEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromTokenRequest: fxIdWebFeaturesAuthAuthenticateFromTokenRequest }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using vk.com openapi 
     */
    async fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest',
                'Required parameter "fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/authenticate_from_vkontaktecom_openapi`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user using vk.com openapi 
     */
    async fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiEndpoint(fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest: FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiResponse> {
        const response = await this.fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiEndpointRaw({ fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest: fxIdWebFeaturesAuthAuthenticateFromVkontakteComOpenApiRequest }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user from \'external id\' authentication (FxLauncher) to fxid 
     */
    async fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest',
                'Required parameter "fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/authenticate_to_fxid_adapter_for_external_id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user from \'external id\' authentication (FxLauncher) to fxid 
     */
    async fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdEndpoint(fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponse> {
        const response = await this.fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdEndpointRaw({ fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest: fxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequest }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fxIdWebFeaturesAuthAuthenticateToFxIdEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateToFxIdEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse>> {
        if (requestParameters['fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest',
                'Required parameter "fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateToFxIdEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auth/authenticate_to_fxid`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestToJSON(requestParameters['fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseFromJSON(jsonValue));
    }

    /**
     */
    async fxIdWebFeaturesAuthAuthenticateToFxIdEndpoint(fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse> {
        const response = await this.fxIdWebFeaturesAuthAuthenticateToFxIdEndpointRaw({ fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest: fxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user for \'external id\' authentication (FxLauncher) 
     */
    async fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpointRaw(requestParameters: FxIdWebFeaturesAuthAuthenticateWithExternalIdEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse>> {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError(
                'game',
                'Required parameter "game" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpoint().'
            );
        }

        if (requestParameters['fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest',
                'Required parameter "fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest" was null or undefined when calling fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/authenticate_with_external_id/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestToJSON(requestParameters['fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthAuthenticateWithExternalIdResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Authenticates user for \'external id\' authentication (FxLauncher) 
     */
    async fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpoint(game: string, fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest: FxIdWebFeaturesAuthAuthenticateWithExternalIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthAuthenticateWithExternalIdResponse> {
        const response = await this.fxIdWebFeaturesAuthAuthenticateWithExternalIdEndpointRaw({ game: game, fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest: fxIdWebFeaturesAuthAuthenticateWithExternalIdRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Получает токен из игры, и если игрок подключен, то выдает ему токен для fxid
     */
    async fxIdWebFeaturesAuthCreateTempTokenEndpointRaw(requestParameters: FxIdWebFeaturesAuthCreateTempTokenEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthCreateTempTokenResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthCreateTempTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthCreateTempTokenRequest',
                'Required parameter "fxIdWebFeaturesAuthCreateTempTokenRequest" was null or undefined when calling fxIdWebFeaturesAuthCreateTempTokenEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auth/create_temp_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthCreateTempTokenRequestToJSON(requestParameters['fxIdWebFeaturesAuthCreateTempTokenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthCreateTempTokenResponseFromJSON(jsonValue));
    }

    /**
     * Получает токен из игры, и если игрок подключен, то выдает ему токен для fxid
     */
    async fxIdWebFeaturesAuthCreateTempTokenEndpoint(fxIdWebFeaturesAuthCreateTempTokenRequest: FxIdWebFeaturesAuthCreateTempTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthCreateTempTokenResponse> {
        const response = await this.fxIdWebFeaturesAuthCreateTempTokenEndpointRaw({ fxIdWebFeaturesAuthCreateTempTokenRequest: fxIdWebFeaturesAuthCreateTempTokenRequest }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fxIdWebFeaturesAuthLogoutEndpointRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auth/logout`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async fxIdWebFeaturesAuthLogoutEndpoint(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.fxIdWebFeaturesAuthLogoutEndpointRaw(initOverrides);
    }

    /**
     */
    async fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthEndpointRaw(requestParameters: FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest',
                'Required parameter "fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest" was null or undefined when calling fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/oauth/mygames/info`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequestToJSON(requestParameters['fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponseFromJSON(jsonValue));
    }

    /**
     */
    async fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthEndpoint(fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest: FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthResponse> {
        const response = await this.fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthEndpointRaw({ fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest: fxIdWebFeaturesAuthOauthInfoAuthenticateWithExternalIdMyGamesOauthRequest }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Using mygames data to transfer account 
     */
    async fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthEndpointRaw(requestParameters: FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest',
                'Required parameter "fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest" was null or undefined when calling fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/oauth/mygames/transfer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequestToJSON(requestParameters['fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts`, `accounts_connections`  Using mygames data to transfer account 
     */
    async fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthEndpoint(fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest: FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthResponse> {
        const response = await this.fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthEndpointRaw({ fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest: fxIdWebFeaturesAuthOauthTransferAuthenticateWithExternalIdMyGamesOauthRequest }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts_connections`  Connects twitch account 
     */
    async fxIdWebFeaturesAuthTwitchConnectEndpointRaw(requestParameters: FxIdWebFeaturesAuthTwitchConnectEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthTwitchConnectRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthTwitchConnectRequest',
                'Required parameter "fxIdWebFeaturesAuthTwitchConnectRequest" was null or undefined when calling fxIdWebFeaturesAuthTwitchConnectEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auth/twitch/connect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthTwitchConnectRequestToJSON(requestParameters['fxIdWebFeaturesAuthTwitchConnectRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`, `accounts_connections`  Connects twitch account 
     */
    async fxIdWebFeaturesAuthTwitchConnectEndpoint(fxIdWebFeaturesAuthTwitchConnectRequest: FxIdWebFeaturesAuthTwitchConnectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdApplicationHandlersAuthConnectTwitchAccountHandlerConnectTwitchAccountHandlerResponse> {
        const response = await this.fxIdWebFeaturesAuthTwitchConnectEndpointRaw({ fxIdWebFeaturesAuthTwitchConnectRequest: fxIdWebFeaturesAuthTwitchConnectRequest }, initOverrides);
        return await response.value();
    }

    /**
     * **MUTATES:** `social_identifiers`  Refreshes twitch\'s token 
     */
    async fxIdWebFeaturesAuthTwitchRefreshAccessTokenEndpointRaw(requestParameters: FxIdWebFeaturesAuthTwitchRefreshAccessTokenEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponse>> {
        if (requestParameters['fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest',
                'Required parameter "fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest" was null or undefined when calling fxIdWebFeaturesAuthTwitchRefreshAccessTokenEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/auth/twitch/refresh_token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequestToJSON(requestParameters['fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponseFromJSON(jsonValue));
    }

    /**
     * **MUTATES:** `social_identifiers`  Refreshes twitch\'s token 
     */
    async fxIdWebFeaturesAuthTwitchRefreshAccessTokenEndpoint(fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest: FxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdApplicationHandlersAuthRefreshTwitchAccountTokenHandlerRefreshTwitchAccountTokenHandlerResponse> {
        const response = await this.fxIdWebFeaturesAuthTwitchRefreshAccessTokenEndpointRaw({ fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest: fxIdWebFeaturesAuthTwitchRefreshAccessTokenRequest }, initOverrides);
        return await response.value();
    }

    /**
     */
    async fxIdWebFeaturesAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenRaw(requestParameters: FxIdWebFeaturesAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult>> {
        if (requestParameters['fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand'] == null) {
            throw new runtime.RequiredError(
                'fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand',
                'Required parameter "fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand" was null or undefined when calling fxIdWebFeaturesAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/auth/validate-external-id-auth-game-access-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommandToJSON(requestParameters['fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResultFromJSON(jsonValue));
    }

    /**
     */
    async fxIdWebFeaturesAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessToken(fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand: FxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxGamesLibWebRpcContractsFxGamesResponseOfValidateExternalIdAuthGameAccessTokenResult> {
        const response = await this.fxIdWebFeaturesAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenRaw({ fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand: fxIdApplicationHandlersAuthValidateExternalIdAuthGameAccessTokenValidateExternalIdAuthGameAccessTokenCommand }, initOverrides);
        return await response.value();
    }

    /**
     * ВНИМАНИЕ этот userInfo заточен на работу с AuthenticateWithExternalId GameAccess токенами Если вы хотите валидировать другие - сделайте рядом другой эндпоинт или добавьте query параметр
     */
    async getFxIdWebFeaturesAuthOauthUserInfoEndpointRaw(requestParameters: GetFxIdWebFeaturesAuthOauthUserInfoEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthOauthUserInfoResponse>> {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError(
                'game',
                'Required parameter "game" was null or undefined when calling getFxIdWebFeaturesAuthOauthUserInfoEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/auth/oauth/userinfo/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthOauthUserInfoResponseFromJSON(jsonValue));
    }

    /**
     * ВНИМАНИЕ этот userInfo заточен на работу с AuthenticateWithExternalId GameAccess токенами Если вы хотите валидировать другие - сделайте рядом другой эндпоинт или добавьте query параметр
     */
    async getFxIdWebFeaturesAuthOauthUserInfoEndpoint(game: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthOauthUserInfoResponse> {
        const response = await this.getFxIdWebFeaturesAuthOauthUserInfoEndpointRaw({ game: game }, initOverrides);
        return await response.value();
    }

    /**
     * ВНИМАНИЕ этот userInfo заточен на работу с AuthenticateWithExternalId GameAccess токенами Если вы хотите валидировать другие - сделайте рядом другой эндпоинт или добавьте query параметр
     */
    async postFxIdWebFeaturesAuthOauthUserInfoEndpointRaw(requestParameters: PostFxIdWebFeaturesAuthOauthUserInfoEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FxIdWebFeaturesAuthOauthUserInfoResponse>> {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError(
                'game',
                'Required parameter "game" was null or undefined when calling postFxIdWebFeaturesAuthOauthUserInfoEndpoint().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/auth/oauth/userinfo/{Game}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesAuthOauthUserInfoResponseFromJSON(jsonValue));
    }

    /**
     * ВНИМАНИЕ этот userInfo заточен на работу с AuthenticateWithExternalId GameAccess токенами Если вы хотите валидировать другие - сделайте рядом другой эндпоинт или добавьте query параметр
     */
    async postFxIdWebFeaturesAuthOauthUserInfoEndpoint(game: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FxIdWebFeaturesAuthOauthUserInfoResponse> {
        const response = await this.postFxIdWebFeaturesAuthOauthUserInfoEndpointRaw({ game: game }, initOverrides);
        return await response.value();
    }

}
